import { generateBaseQueryKeysList } from '@/queries/utils';
import { BASE_QUERY_KEYS } from '@/queries/consts';

export const TX_CENTERS_KEYS = {
  main: 'tx-centers',
};

export const txCentersQueryKeys = {
  ...generateBaseQueryKeysList(TX_CENTERS_KEYS.main),
  getMyTxCenter: () => [TX_CENTERS_KEYS.main, BASE_QUERY_KEYS.item, BASE_QUERY_KEYS.my] as const,
};
